export default "__VITE_ASSET__BOcjBbQB__"